import { useEffect, useState } from 'react';

// Breakpoints shared between CSS and JSX. Keep in sync with the @media blocks
// in studio/src/client/styles/ (canvas.css, direct-edit.css, command-bar.css,
// dashboard.css) and workbench/src/workbench.css — these constants are the
// only written-down copy of the numbers, so a query changed here is a query
// that must change there too.
//
// PHONE is the stacked-layout line: the editor stacks strip/preview/chat, the
// category rail collapses, drawers go full-width.
//
// TABLET is a WIDER, separate question and not a typo for PHONE: it is where
// the app header stops fitting on one line. Between 768 and 1100 the bar still
// has to carry the brand, four nav items, a search box and five or six
// controls, which is why it used to wrap into several rows — so the header's
// overflow folds into the sheet from here down, well before phone width.
//
// COARSE is not about width at all: a touch pointer loses the drag/resize
// affordances however big the screen is.
export const PHONE_QUERY = '(max-width: 767px)';
export const TABLET_QUERY = '(max-width: 1024px)';
export const COARSE_QUERY = '(hover: none) and (pointer: coarse)';

/** True while `query` matches; re-renders on viewport/orientation change. */
export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}
